import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../../store/root-reducer';
import { initializeBetterBugs } from '../../utils/initialize-third-party-integrations';

// const BETTERBUG_API_KEY = 'd0f2dd09abc7c58441f353c5ef20483b';

interface UseBetterBugsIntegrationWithConfigProps {
  enable?: boolean;
  apiKey?: string;
  onError?: (error: any) => void;
}

const useBetterBugsIntegrationWithConfig = ({
  enable = false,
  apiKey = process.env.REACT_APP_CFG_CORE_03,
  onError,
}: UseBetterBugsIntegrationWithConfigProps = {}) => {
  const email = useSelector((state: RootState) => state?.home?.email);
  useEffect(() => {
    if (!enable) return;

    try {
      if (apiKey) {
        initializeBetterBugs(apiKey, email);
      }
    } catch (error) {
      if (process.env.NODE_ENV === 'development') {
        // eslint-disable-next-line no-console
        console.error('Error initializing BetterBugs:', error);
      }
      onError?.(error);
    }
  }, [enable, apiKey, email, onError]);

  return null;
};

export default useBetterBugsIntegrationWithConfig;
